import axios from 'axios';
import { getConfig } from '../../../config/apiConfig';
import authService from '../../../authentication/AuthorizeService';

const getUserProfile = async (id) => {
  // Get auth header config
  const config = await getConfig();
  let userId = id;
  if (!userId) {
    userId = await authService.getMaskedUserId();
  }

  const url = `api/rcore/userprofile?userId=${userId}`;

  return axios
    .get(url, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      throw err.response;
    });
};

export default getUserProfile;
